import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';

import './styles/tokens.css';
import './styles/global.css';
import './styles/login.css';
import './styles/heart.css';
import './styles/countdown.css';
import './styles/admin.css';
import './styles/chat.css';
import './styles/responsive.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
